import { render, staticRenderFns } from "./tiki.vue?vue&type=template&id=db284e36&scoped=true"
import script from "./tiki.vue?vue&type=script&lang=js"
export * from "./tiki.vue?vue&type=script&lang=js"
import style0 from "./tiki.vue?vue&type=style&index=0&id=db284e36&prod&scoped=true&lang=css"
import style1 from "./tiki.vue?vue&type=style&index=1&id=db284e36&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db284e36",
  null
  
)

export default component.exports